import styled from 'styled-components';
import { getToken } from '@optimus-web/common';

export const SearchItemDescriptionPrefix = styled.span`
    color: ${getToken('textStaticTertiary')};
`;
export const SearchItemDescriptionValue = styled.span`
    color: ${getToken('textStaticPrimary')};
`;
export const SearchItemDescriptionSeparator = styled.span`
    color: ${getToken('textDisabled')};
`;
